/* AK Hardwood — shared estimated-delivery line (brief 2026-10-16 "Weybridge page", Part A2).
 *
 *  Fills every [data-ak-dispatch] element printed by snippets/ak-dispatch.liquid
 *  (Weybridge product page + floor card) with the delivery-date line.
 *  Loaded once per page from snippets/ak-boot.liquid (deferred).
 *
 *  The AKDispatch block below is copied VERBATIM from assets/ak-cart.js
 *  (same working-day maths, same Europe/London clock), so the page, the card
 *  and the basket always agree. Bank holidays come from window.AK_BANK_HOLIDAYS,
 *  printed by ak-boot from snippets/ak-bank-holidays.liquid. The cart section,
 *  the Bona page and snippets/ak-dispatch-line.liquid still keep their own copies.
 *
 *  Element data attributes (all from the snippet):
 *    data-cutoff "HH:MM" · data-lead working days · data-stock in|low|out|''
 *    data-qty    optional custom.stock_qty_m2 (m²) · data-need m² the order needs
 *                (set by the product page's calculator; blank = fits)
 *    data-form   long | short
 *    data-t-before / data-t-after / data-t-limited / data-t-out / data-t-short
 *                wording templates from section or theme settings. Tokens:
 *                {countdown} {date} {cutoff} {day} {area}
 *  "Fits" = qty blank, or qty >= need. Low stock that fits reads exactly like in stock.
 */
var AKDispatch = (function () {
  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var fmt = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short', hour12: false
  });
  // London wall-clock parts of an instant (never the visitor's clock).
  function londonParts(date) {
    var p = {};
    fmt.formatToParts(date).forEach(function (x) { p[x.type] = x.value; });
    return { y: +p.year, m: +p.month, d: +p.day, hh: (+p.hour) % 24, mm: +p.minute, ss: +p.second, wd: WD.indexOf(p.weekday) };
  }
  // Calendar days are handled as UTC-midnight Dates so arithmetic is DST-proof.
  function day(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
  function iso(dt) { return dt.toISOString().slice(0, 10); }
  function addDays(dt, n) { return new Date(dt.getTime() + n * 86400000); }
  function isWorkingDay(dt, holidays) {
    var wd = dt.getUTCDay();
    return wd >= 1 && wd <= 5 && !holidays[iso(dt)];
  }
  function nextWorkingDay(dt, holidays) {
    var d = addDays(dt, 1), guard = 0;
    while (!isWorkingDay(d, holidays) && guard++ < 60) d = addDays(d, 1);
    return d;
  }
  function parseHolidays(text) {
    var set = {};
    String(text || '').split(/[\s,;]+/).forEach(function (s) { if (/^\d{4}-\d{2}-\d{2}$/.test(s)) set[s] = true; });
    return set;
  }
  function parseCutoff(s) {
    var m = /^(\d{1,2}):(\d{2})$/.exec(String(s || '').trim());
    if (!m) return null;
    var hh = +m[1], mm = +m[2];
    if (hh > 23 || mm > 59) return null;
    return hh * 60 + mm;
  }
  /**
   * @param {Date} now        instant
   * @param {string} cutoff   "HH:MM" London time
   * @param {number} leadDays working days from effective order day
   * @param {object} holidays set from parseHolidays
   * @returns {{delivery:Date, effective:Date, beforeCutoff:boolean, msToCutoff:number, label:string}|null}
   */
  function compute(now, cutoff, leadDays, holidays) {
    var cut = parseCutoff(cutoff);
    var lead = parseInt(leadDays, 10);
    if (cut === null || isNaN(lead) || lead < 0) return null;
    var p = londonParts(now);
    var today = day(p.y, p.m, p.d);
    var nowMin = p.hh * 60 + p.mm;
    var beforeCutoff = isWorkingDay(today, holidays) && nowMin < cut;
    var effective = beforeCutoff ? today : nextWorkingDay(today, holidays);
    var delivery = effective;
    for (var i = 0; i < lead; i++) delivery = nextWorkingDay(delivery, holidays);
    var msToCutoff = beforeCutoff ? ((cut - nowMin) * 60 - p.ss) * 1000 : 0;
    return {
      delivery: delivery, effective: effective, beforeCutoff: beforeCutoff, msToCutoff: msToCutoff,
      label: WD[delivery.getUTCDay()] + ' ' + delivery.getUTCDate() + ' ' + MON[delivery.getUTCMonth()],
      iso: iso(delivery)
    };
  }
  function countdown(ms) {
    var m = Math.max(0, Math.ceil(ms / 60000));
    var h = Math.floor(m / 60), r = m % 60;
    return h > 0 ? h + 'h ' + r + 'm' : r + 'm';
  }
  return { compute: compute, countdown: countdown, parseHolidays: parseHolidays, londonParts: londonParts, isWorkingDay: isWorkingDay };
})();

(function () {
  'use strict';
  if (window.AKDispatchUI) return;
  var WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var holidays = AKDispatch.parseHolidays(window.AK_BANK_HOLIDAYS || '');

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  // Escape the template, then put each token's value in (bold for the figures).
  function fill(tpl, map) {
    return esc(tpl).replace(/\{(\w+)\}/g, function (m, k) {
      if (!Object.prototype.hasOwnProperty.call(map, k)) return m;
      var v = map[k];
      return (v && typeof v === 'object') ? '<b>' + esc(v.text) + '</b>' : esc(v);
    });
  }
  function countdownText(ms) {
    var m = Math.max(0, Math.ceil(ms / 60000));
    var h = Math.floor(m / 60), r = m % 60;
    return h > 0 ? h + ' h ' + r + ' min' : r + ' min';
  }
  function fmtArea(n) {
    return String(Math.round(n * 100) / 100);
  }
  function show(el, state, html) {
    var t = el.querySelector('[data-ak-dispatch-text]') || el;
    if (!html) { el.hidden = true; el.removeAttribute('data-state'); return; }
    t.innerHTML = html;
    el.setAttribute('data-state', state);
    el.hidden = false;
  }

  function render(el, now) {
    if (!el) return;
    now = now || (window.__akDispatchNow ? window.__akDispatchNow() : new Date());
    var d = el.dataset;
    var stock = String(d.stock || '').toLowerCase();
    if (stock === 'out') { show(el, 'out', d.tOut ? fill(d.tOut, {}) : ''); return; }
    var r = AKDispatch.compute(now, d.cutoff, d.lead, holidays);
    if (!r) { show(el, '', ''); return; }
    el.setAttribute('data-iso', r.iso);
    var qty = parseFloat(d.qty), need = parseFloat(d.need);
    if (stock === 'low' && !isNaN(qty) && !isNaN(need) && need > qty) {
      show(el, 'limited', fill(d.tLimited || '', { area: fmtArea(need) }));
      return;
    }
    var date = { text: r.label, bold: true };
    if (d.form === 'short') { show(el, 'in', fill(d.tShort || '', { date: date })); return; }
    if (r.beforeCutoff) {
      show(el, 'in', fill(d.tBefore || '', { countdown: { text: countdownText(r.msToCutoff), bold: true }, date: date, cutoff: d.cutoff, day: WD[r.effective.getUTCDay()] }));
    } else {
      show(el, 'in', fill(d.tAfter || '', { cutoff: d.cutoff, day: WD[r.effective.getUTCDay()], date: date }));
    }
  }

  function scan(root) {
    var now = window.__akDispatchNow ? window.__akDispatchNow() : new Date();
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-ak-dispatch]'), function (el) { render(el, now); });
  }

  window.AKDispatchUI = { render: render, scan: scan, compute: function (now, c, l) { return AKDispatch.compute(now, c, l, holidays); } };

  function boot() {
    scan();
    setInterval(scan, 30000);
    // Collection filters, search and rails re-render cards after load: fill the new ones.
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function (list) {
        if (pending) return;
        for (var i = 0; i < list.length; i++) {
          var added = list[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && (n.hasAttribute('data-ak-dispatch') || n.querySelector('[data-ak-dispatch]'))) {
              pending = true;
              setTimeout(function () { pending = false; scan(); }, 50);
              return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
